import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useAssignmentTemplatesTabViewModel = ({
  inspectionTemplateId,
  refresh,
}) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedAssignmentTemplate, setSelectedAssignmentTemplate] = useState(
    {}
  );

  const stateManager = useComponentState();

  const openDeleteModal = (orderTemplate) => {
    setIsDeleteModalOpen(true);
    setSelectedAssignmentTemplate(orderTemplate);
  };

  const openEditModal = (orderTemplate) => {
    setSelectedAssignmentTemplate(orderTemplate);
    setIsEditModalVisible(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const closeEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedAssignmentTemplate({});
  };

  const deleteAssignmentTemplate = () => {
    stateManager.run(async () => {
      const {
        id: assignmentTemplateId,
        name,
        modifiedOn,
      } = selectedAssignmentTemplate;

      const { status } =
        await taskService.inspectionTemplateAssignmentTemplateMaps.deleteByOrderAssignmentTemplateId(
          {
            inspectionTemplateId,
            assignmentTemplateId,
            data: { modifiedOn },
            toastMessageConfig: {
              success: {
                text: `${name} was deleted.`,
              },
            },
          }
        );

      if (status === HTTP_STATUSES.OK) {
        refresh();
      }

      closeDeleteModal();
    });
  };

  const handleUpdateOrderTemplateAssignmentTemplate = (data) => {
    stateManager.run(async () => {
      const { status } =
        await taskService.inspectionTemplateAssignmentTemplateMaps.updateByOrderAssignmentTemplateId(
          {
            inspectionTemplateId,
            assignmentTemplateId: selectedAssignmentTemplate.id,
            data,
            toastMessageConfig: {
              success: {
                text: `${data.name} was updated successfully.`,
              },
            },
          }
        );

      if (status === HTTP_STATUSES.OK) {
        closeEditModal();
        refresh();
      }
    });
  };

  return {
    selectedAssignmentTemplate,
    isDeleteModalOpen,
    deleteAssignmentTemplate,
    openDeleteModal,
    closeDeleteModal,
    closeEditModal,
    openEditModal,
    isEditModalVisible,
    handleUpdateOrderTemplateAssignmentTemplate,
  };
};
